module.exports = __webpack_public_path__ + "img/Leysen-icon.cc4a332f.png";